import { createContext, useEffect, useState } from "react";

export const ItemsContext=createContext(null)

const ItemsContextProvider=({children})=>{

    const [items,setItems]=useState(JSON.parse(localStorage.getItem("items")) || [])
    const [users,setUsers]=useState(JSON.parse(localStorage.getItem("users")) || [])
    const [loggedInUser,setLoggedInUser]=useState(localStorage.getItem("loggedInUser") || null)
    const [login,setLogin]=useState(false)
    const [signup,setSignup]=useState(false)
    const [presentation,setPresentation]=useState(true)
    const [userItems, setUserItems] = useState([])

    const getItemsForUser = (items, loggedInUser) => {
        return items.filter((item) => item.user === loggedInUser);
      }
    useEffect(() => {
        const userItems = getItemsForUser(items, loggedInUser)
        setUserItems(userItems)
    }, [items,loggedInUser])
    useEffect(()=>{
        localStorage.setItem("items",JSON.stringify(items));
    },[items])
    useEffect(()=>{
        localStorage.setItem("users",JSON.stringify(users));
    },[users])
    useEffect(() => {
        const loggedInUser = localStorage.getItem("loggedInUser");
        if (loggedInUser) {
        setLoggedInUser(loggedInUser);
        } else {
        setLoggedInUser(null);
        }
    }, [])
    useEffect(() => {
        if (loggedInUser) {
        localStorage.setItem("loggedInUser", loggedInUser);
        } else {
        localStorage.removeItem("loggedInUser");
        }
    }, [loggedInUser])

    //Add item
   const addItem=(title, details)=>{
    const newItem={
        id:Date.now(),
        user: loggedInUser,
        title,
        details,
        date:Date.now(),
        fulfilled:false
   }
   setItems([...items,newItem])
    }

    //Delete item
    const deleteItem=(id)=>{
        const remainingItems=items.filter(item=>item.id !== id)
        setItems(remainingItems)
    }

    //Update item
    const updateItem=(id,updatedItem)=>{
        const updatedItems=items.map(item=>item.id===id?updatedItem:item)
        setItems(updatedItems)
    }

    //Register user
    const registerUser=(username,email,password)=>{
        const newUser={
            username,email,password,registered:new Date(Date.now()).toLocaleTimeString("cs-CZ")
        }
        const newUsers={...users}
        newUsers[email]={...newUser,userItems:[]}
        setUsers(newUsers)
    }

    //Login user
    const loginUser=(email,password)=>{
        const user=users[email];
        if(user && user.password===password){
            setLoggedInUser(email)
            localStorage.setItem("loggedInUser",email)
            return true
        }
        return false
    }

    //Logout user
    const logoutUser = () => {
        setLoggedInUser(null)
        setLogin(false)
        setSignup(false)
        localStorage.removeItem("loggedInUser")
    }

 

const myValues={items,setItems,users,setUsers,addItem,updateItem,deleteItem,registerUser,loginUser,
    logoutUser,loggedInUser,userItems, setUserItems,setLogin,setSignup,login,signup,
    setLoggedInUser,presentation,setPresentation}

    return(
        <ItemsContext.Provider value={myValues}>
            {children}
        </ItemsContext.Provider>
    )
}

export default ItemsContextProvider

